import { BasicButtonFormField, CancelButtonFormField, ConfirmButtonInverted } from 'components/button/button.styled'
import { CustomForm } from 'components/form/customForm'
import { FormField } from 'components/form/customFormField'
import { ContributorsContainer, FormFieldContainer, Label } from 'components/form/form.style'
import { ImageUploadSection } from 'components/imageUploadSection'
import { useShowForm, UseShowFormProps } from 'hooks/admin/useShows'
import React, { Fragment } from 'react'
import { ShowWithImages } from 'types/Show'

interface ShowFormProps extends UseShowFormProps {
    onSuccess?: () => void
    partnerId?: string
}

export const ShowForm: React.FC<ShowFormProps> = ({ initialData, onClose, queryKey = ['shows'], onSuccess, partnerId }: ShowFormProps) => {
    const showWithImagesData = initialData as ShowWithImages
    const {
        control,
        handleSubmit,
        errors,
        loading,
        setUploadedImages,
        coverImageOptions,
        setCoverImageOptions,
        coverImage,
        setCoverImage,
        fields,
        append,
        remove,
        onUpload,
        setValue,
    } = useShowForm({ initialData, queryKey, onClose, partnerId })

    return (
        <>
            <CustomForm
                handleSubmit={handleSubmit}
                loading={loading}
                initialData={showWithImagesData}
                onClose={onClose}
                onSuccess={onSuccess}
            >
                <ImageUploadSection
                    title="Képek"
                    description="Egy kép kijelölhető a műsor borítóképeként. A kiválasztott kép nem fog külön megjelenni a galériában."
                    onUpload={onUpload}
                    customImageOptions={coverImageOptions}
                    setCustomImageOptions={setCoverImageOptions}
                    customImage={coverImage}
                    setCustomImage={setCoverImage}
                    setUploadedImages={setUploadedImages}
                    allowMultiple={true}
                />
                <FormField
                    name="name"
                    control={control}
                    errors={errors}
                    label="Műsor címe"
                    placeholder="Cím"
                    rules={{
                        required: 'A cím megadása kötelező.',
                        maxLength: {
                            value: 100,
                            message: 'A cím legfeljebb 100 karakter hosszú lehet.',
                        },
                    }}
                />
                <FormField
                    name="description"
                    control={control}
                    errors={errors}
                    label="Műsor leírása"
                    placeholder="Leírás..."
                    rules={{ required: 'A leírás megadása kötelező!' }}
                    textarea
                />
                <FormField
                    name="genre"
                    control={control}
                    errors={errors}
                    label="Műsor műfaja"
                    placeholder="Műfaj"
                    rules={{
                        required: 'A műfaj megadása kötelező!',
                        maxLength: {
                            value: 50,
                            message: 'A műfaj legfeljebb 50 karakter hosszú lehet.',
                        },
                    }}
                />
                <Fragment>
                    <Label>Közreműködők</Label>
                    {fields.map((field, index) => (
                        <ContributorsContainer key={field.id}>
                            <FormFieldContainer>
                                <FormField
                                    name={`contributors[${index}].role`}
                                    control={control}
                                    errors={errors}
                                    placeholder="Szerep"
                                    label=""
                                />
                            </FormFieldContainer>
                            <FormFieldContainer>
                                <FormField
                                    name={`contributors[${index}].responsible`}
                                    control={control}
                                    errors={errors}
                                    placeholder="Felelős"
                                    label=""
                                />
                            </FormFieldContainer>
                            <CancelButtonFormField label="Eltávolítás" type="button" onClick={() => remove(index)} />
                        </ContributorsContainer>
                    ))}
                    <BasicButtonFormField
                        label="Új közreműködő"
                        type="button"
                        icon="pi pi-plus"
                        onClick={() => append({ role: '', responsible: '' })}
                    />
                </Fragment>
            </CustomForm>
            {process.env.NODE_ENV === 'development' && (
                <ConfirmButtonInverted
                    onClick={async () => {
                        setValue('name', 'Teszt Műsor ' + Math.floor(Math.random() * 1000))
                        setValue('description', 'Ez egy automatikusan generált teszt leírás.')
                        setValue('genre', 'Dráma')

                        // Fill contributors
                        remove() // clear all contributors
                        append({ role: 'Rendező', responsible: 'Teszt Elek' })
                        append({ role: 'Főszereplő', responsible: 'Minta Áron' })

                        // Fetch random image and simulate upload
                        const imageUrl = `https://picsum.photos/800/600?random=${Math.floor(Math.random() * 1000)}`
                        const response = await fetch(imageUrl)
                        const blob = await response.blob()

                        // Generate a filename and trigger the download
                        const blobUrl = URL.createObjectURL(blob)
                        const link = document.createElement('a')
                        link.href = blobUrl
                        link.download = `random-image-${Date.now()}.jpg` // You can customize the name
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        URL.revokeObjectURL(blobUrl)
                    }}
                >
                    Tesztadatok kitöltése
                </ConfirmButtonInverted>
            )}
        </>
    )
}
